import {makeActionCreators} from '../redux';

/**
 * @param {ReactReduxModal} reactReduxModal
 * @param {ReduxRequest} reduxRequest
 * @param {ReduxObservableListExportsOptions} options
 * @return {ReduxObservableListExportsActions}
 */
export function buildReportActions(reactReduxModal, reduxRequest, options) {
  return makeActionCreators(options.prefix, [{
    name: 'applyFilter',
    type: 'APPLY_FILTER',
  }], {
    ...reactReduxModal.actions,
    ...reduxRequest.actions,
  });
}

/**
 * @typedef {FilterData} ReduxListExports~FilterData
 * @property {ReportFormat} format
 */

/**
 * @typedef {Object} ReduxListExports~RequestReportSuccessPayload
 * @property {RequestStatus} status
 */

/**
 * @typedef {Object} ReduxListExports~RequestReportErrorPayload
 * @property {Error} err
 */

/**
 * @typedef {ReactReduxModalActions} ReduxObservableListExportsActions
 * @property {Function|ReduxActionCreator<ReduxListExports~FilterData>} applyFilter
 * @property {Function|ReduxActionCreator<Void>} sendRequest
 * @property {Function|ReduxActionCreator<ReduxListExports~RequestReportSuccessPayload>} requestSuccess
 * @property {Function|ReduxActionCreator<ReduxListExports~RequestReportErrorPayload>} requestError
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-observable-list-exports/actions.js